import * as React from "react";
import {
  ClubCompetitionRequestApi,
  ClubCompetitionRequestGridDto,
  ClubCompetitionRequestsSearch,
  CompetitionRequestGridDto,
  CompetitionRequestSearch,
} from "../../../../api";
import { useApiService, useTl } from "../../../../hooks";
import { useGlobalData } from "../../../../contexts";
import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import { ETLCodes } from "../../../../locales";
import { CustomDataTable, ExportButton } from "../../../../components";
import { Link } from "react-router-dom";
import { ERoutes } from "../../../../ERoutes";
import moment from "moment";

export interface IClubCompetitionRequestListProps {
  clubId: number;
}

export const ClubCompetitionRequestList: React.FunctionComponent<IClubCompetitionRequestListProps> = ({ clubId }) => {
  const api = useApiService(ClubCompetitionRequestApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const [sobjState, setsobjState] = React.useState<any>();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { requestDate: "DESC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: ClubCompetitionRequestsSearch) => {
      console.log("ClubId is ", clubId);
      setsobjState(
        ClubCompetitionRequestsSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, clubId: clubId })
      );
      return api.baseSearch(
        ClubCompetitionRequestsSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, clubId: clubId })
      );
    },
    [api, clubId, currentLanguage.languageId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.RequestNumber),
        fieldName: "requestNumber",
        render: (row: ClubCompetitionRequestGridDto) => {
          return (
            <Link target="_blank" to={`${ERoutes.competitionRequest}/${row.subRequestId}/detail/view`}>
              {row.requestNumber}
            </Link>
          );
        },
      },
      {
        header: () => t(ETLCodes.RequestDate),
        fieldName: "requestDate",
      },
      {
        header: () => t(ETLCodes.RequestState),
        fieldName: "requestState",
      },
      {
        header: () => t(ETLCodes.CompetitionDate),
        fieldName: "competitionDate",
        render: (row: ClubCompetitionRequestGridDto) =>
          `${moment(row.dateFrom).format("DD/MM/YYYY")}-${moment(row.dateTo).format("DD/MM/YYYY")}`,
      },
    ],
    [t]
  );

  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return (
    <FieldSet
      title={t(ETLCodes.Competitions)}
      rightElement={<ExportButton exportFunction={(sObj) => api.exportXlsFile(sObj)} sObj={sobjState} />}
    >
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
